import React,{Component} from 'react';
import {connect} from 'react-redux';
import { InView }  from 'react-intersection-observer';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {getFullMediaUrl, sortByOrderNum} from 'app/static_func';
import ReactHtmlParser from 'react-html-parser';


//components
import './instruction.scss';
import tablet_icon from 'assets/icons/tablet_icon.svg';
import handsShaking_icon from 'assets/icons/hands_shaking_icon.svg';
import car_portrait_icon from 'assets/icons/car_portrait.svg';
import arrow from 'assets/icons/left_arrow.svg';
import Slider from 'react-slick';


class Instruction extends Component{

    constructor(props){
        super(props);

        this.state = {
            fullView:false
        }

        this.getReactSlide = this.getReactSlide.bind(this);
        this.fullView = this.fullView.bind(this);
    }


    getReactSlide(info,key){
        return(
            <div className='instructionContainer' key={key}>
                <img src={info.image} alt='tablet icon'/>
                <h3 className='secondaryTitle'>{info.secondaryTitle}</h3>
                <div className='smallDivider'/>
                <div className='massage'>{info.massage}</div>
            </div>
        )
    }

    fullView(inView){
        if(inView)
            this.setState({fullView:true});
        else
            this.setState({fullView:false});
    }


    render(){

        const isMobileOrTablet = this.props.deviceState === 'mobile' || this.props.deviceState === 'tablet';
        const flowInformation = sortByOrderNum(this.props.flowInformation);

        let slides = [];

        flowInformation.forEach(item => {
            slides.push({
                image: getFullMediaUrl(item.image.path),
                secondaryTitle: item.title,
                massage: ReactHtmlParser(item.description)});
        });

        const reactSliders = [];
        slides.map((slide,index) =>(
           reactSliders.push(this.getReactSlide(slide,index))
        ));


           const settings = {
               dots: true,
               infinite: false,
               speed: 500,
               slidesToShow: 1,
               slidesToScroll: 1,
               rtl:true,
               initialSlide:reactSliders>0 ? reactSliders.length-1 : 2,
               nextArrow:<img className='leftArrow' src={arrow} alt='\'/>,
               prevArrow:<img className='leftArrow rotateRight'  src={arrow} alt='\'/>
            };

        return(
            <section className='instruction'>
                <h1 className='title'>{this.props.text['instructions_title']}</h1>
                {isMobileOrTablet &&
                <Slider className="slider" {...settings}>
                    {reactSliders}
                </Slider>
                }
                {!isMobileOrTablet &&
                    <InView as = 'div' className='wrapper'
                            onChange={(inView) => this.fullView(inView)}
                            threshold={0.5}>
                        <div className={'instructionContainer fade_right ' + (this.state.fullView ? 'in' : '')}>
                            <img src={flowInformation[0] !== undefined ? getFullMediaUrl(flowInformation[0].image.path):tablet_icon} alt='tablet icon'/>
                            <h3 className='secondaryTitle'>{flowInformation[0]!== undefined ? flowInformation[0].title : 'מצאת רכב שאהבת?'}</h3>
                            <div className='smallDivider'/>
                            <div className='massage'>{flowInformation[0]!== undefined ? ReactHtmlParser(flowInformation[0].description) : 'יופי! רכב החלומות שלך כבר עבר בדיקה על ידינו וקיבל ציון פיפס על פי קריטריונים של תאונות, מצב טכני ומחיר סופי.'}</div>
                        </div>
                        <img className='arrow' src={arrow} alt='arrow'/>
                        <div className={'instructionContainer fade_up ' + (this.state.fullView ? 'in' : '')}>
                            <img src={flowInformation[1] !== undefined ? getFullMediaUrl(flowInformation[1].image.path):handsShaking_icon} alt='tablet icon'/>
                            <h3 className='secondaryTitle'>{flowInformation[1]!== undefined ? flowInformation[1].title : 'מגיעים עד אליך לדייט'}</h3>
                            <div className='smallDivider'/>
                            <div className='massage'>{flowInformation[1]!== undefined ? ReactHtmlParser(flowInformation[1].description) : 'אנחנו מביאים את הרכב עד אליך* לנסיעות מבחן- בבית,במשרד או בכל מקום אחר במחיר סמלי של 100 שח בלבד.'}</div>
                        </div>
                        <img className='arrow' src={arrow} alt='arrow'/>
                        <div className={'instructionContainer fade_left ' + (this.state.fullView ? 'in' : '')}>
                            <img src={flowInformation[2] !== undefined ? getFullMediaUrl(flowInformation[2].image.path):car_portrait_icon} alt='tablet icon'/>
                            <h3 className='secondaryTitle'>{flowInformation[2]!== undefined ? flowInformation[2].title : 'הבנת שזה האחד?'}</h3>
                            <div className='smallDivider'/>
                            <div className='massage'>{flowInformation[2]!== undefined ? ReactHtmlParser(flowInformation[2].description) : 'זה הזמן לרכוש מאיתנו את הרכב, במחיר שהתחייבנו עליו, בלי הפתעות ובלי משא ומתן!'}</div>
                        </div>
                    </InView>
                }
            </section>
        );
    }

}

//add GD categories and deviceState to props
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        flowInformation: store.config.FlowInformation,
        text: store.config.Translations
    }
}
//map a doLgin function to props
const mapDispatchToProps = dispatch => {
    return {

    }
}

//connect to redux store - maps dispatch and redux state to props
export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(Instruction);
